import React, { useState, useEffect } from "react";
import _, { forEach } from "lodash";
import History from "../components/Steps/History";
import Step1 from "../components/Steps/Step1";
import Step2 from "../components/Steps/Step2";
import Step3 from "../components/Steps/Step3";
import Step4 from "../components/Steps/Step4";
import Step5 from "../components/Steps/Step5";
import Step6 from "../components/Steps/Step6";
import { Form, Spin } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import $axios from "../services/axios";
import showCustomNotification from "../components/Common/showCustomNotification";
import moment from "moment";
import dayjs from "dayjs";
import { checkRepayment } from "../helpers/utils";
import RepaymentModal from "../components/Common/RepaymentModal";
import { useSelector, useDispatch } from "react-redux";
import { setIsViewedUnpaidOrder } from "../provider/redirectSlice";
import { DomesticAirlines, InternationalAirlines } from "../helpers/const";
const Home = ({ token }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [listFlight, setListFlight] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tripType, setTripType] = useState("oneWay");
  const [chooseFlight, setChooseFlight] = useState([]);
  const [airports, setAirports] = useState([]);
  const [airlines, setAirlines] = useState([]);
  const [arrival, setArrival] = useState([]);
  const [step, setStep] = useState(null);
  const [bookingInfo, setBookingInfo] = useState({});
  const [filterDay, setFilterDay] = useState("");
  const [filterDayReturn, setFilterDayReturn] = useState("");
  const [loadingSearchFlight, setLoadingSearchFlight] = useState(false);
  const [loadingAirPorts, setLoadingAirPorts] = useState(true);
  const [openRepaymentModal, setOpenRepaymentModal] = useState(true);
  const [dataRepayment, setDataRepayment] = useState(null);
  const [ChoosingStep, setChoosingStep] = useState(1);
  const [countries, setCountries] = useState([]);
  const [fareclass, setFareclass] = useState([]);
  const isViewedUnpaidOrder = useSelector(
    (state) => state.redirect.isViewedUnpaidOrder
  );
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    hanleProcessPaymentReturn();
  }, [location, history, token]);

  const handleBookingInfo = (booking) => {
    setBookingInfo(booking);
  };
  const hanleProcessPaymentReturn = async () => {
    const queryParams = new URLSearchParams(location.search);
    const amount = queryParams.get("amount");
    const payment_type = queryParams.get("payment_type");
    const reference_number = queryParams.get("reference_number");
    const status = queryParams.get("status");
    const trans_ref_no = queryParams.get("trans_ref_no");
    const website_id = queryParams.get("website_id");
    const signature = queryParams.get("signature");
    if (
      amount &&
      payment_type &&
      reference_number &&
      status &&
      trans_ref_no &&
      website_id &&
      signature
    ) {
      setStep(6);
    } else if (location.pathname === "/history") {
      setStep(0);
    } else if (step === null && token) {
      setStep(1);
    }
  };

  useEffect(() => {
    if (location.pathname === "/history") {
      setStep(0);
    } else if (location.pathname === "/vemaybay" && step === 0) {
      setStep(1);
    }
  }, [location.pathname, step]);

  useEffect(() => {
    filterDay && fetchSearchFlight(form.getFieldValue());
  }, [filterDay, filterDayReturn]);

  useEffect(() => {
    if (token && step && step === 1 && !isViewedUnpaidOrder && airports) {
      fetchUnpaidOrder();
    }
  }, [step, token, airports]);

  const fetchUnpaidOrder = async () => {
    const end = dayjs();
    const start = end.subtract(6, "day");
    const startTime = start.format("DD/MM/YYYY");
    const endTime = end.format("DD/MM/YYYY");
    try {
      const res = await $axios.$get(
        `/order-flight/findByAllUser?startdate=${startTime}&enddate=${endTime}&page=${1}&pageSize=10`
      );
      const histories = res.data.data.data;
      if (histories.length > 0) {
        const lastBooking = histories[0];
        if (!lastBooking) return;
        if (
          checkRepayment(lastBooking?.createdat) &&
          lastBooking?.paymentstatus === "PayLater" && lastBooking?.status === "Create"
        ) {
          setDataRepayment(lastBooking);
          setOpenRepaymentModal(true);
        }
      }
    } catch (error) {
    } finally {
    }
  };

  const getFareClass = async () => {
    setLoading(true);
    try {
      const res = await $axios.$get("/honghatrip/airline-fareclass");
      setFareclass(res.data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchSearchFlight = async (values) => {
    setLoadingSearchFlight(true);
    const isDomestic =
      _.some(airports, { code: values.startpoint, countrycode: "VN" }) &&
      _.some(airports, { code: values.endpoint, countrycode: "VN" });
    try {
      const requests = (
        isDomestic ? DomesticAirlines : InternationalAirlines
      ).map(async (system) => {
        try {
          const airline = _.find(airlines, (air) => air.code === system);
          const res = await $axios.$post(`/honghatrip/search`, {
            Adt: values.Adt,
            Chd: values.Chd,
            Inf: values.Inf,
            System: system,
            Airlines: [],
            PricingType: 0,
            Flights:
              tripType === "oneWay"
                ? [
                    {
                      Leg: 0,
                      startpoint: values.startpoint,
                      endpoint: values.endpoint,
                      DepartDate: filterDay,
                    },
                  ]
                : [
                    {
                      Leg: 0,
                      startpoint: values.startpoint,
                      endpoint: values.endpoint,
                      DepartDate: filterDay,
                    },
                    {
                      Leg: 0,
                      startpoint: values.endpoint,
                      endpoint: values.startpoint,
                      DepartDate: filterDayReturn,
                    },
                  ],
          });

          return {
            airline,
            data: res?.data?.data?.faredatas || [],
          };
        } catch (err) {
          return {
            airline: {},
            data: [],
          };
        }
      });

      // Chạy tất cả promise song song
      const results = await Promise.all(requests);

      const mergedFlights = results.flatMap((item) =>
        item.data.map((flight) => ({
          ...flight,
          airline: item.airline,
        }))
      ).filter(fare => _.some(fare.options[0]?.flights, f => _.some(f.segments, s => s.seatavl > 0)));

      const mergedFlightsNew = mergedFlights.map((item) => {
        _.forEach(item.options?.[0]?.flights, (f) => {
          _.forEach(f.segments, (s) => {
            const fareclassname =
              _.find(
                fareclass,
                (fare) =>
                  fare.airlinecode === item.airline.code &&
                  s.fareclass === fare.fareclassvalue
              )?.fareclassname || s.fareclass;
            s["fareclassname"] = fareclassname;
          });
        });
        return item;
      })
      setListFlight(mergedFlightsNew);
    } catch (error) {
      setListFlight([]);
    } finally {
      setTimeout(() => {
        setLoadingSearchFlight(false);
      }, 1000);
    }
  };

  const getAirPorts = async () => {
    try {
      setLoadingAirPorts(true);
      const response = await $axios.$get(`/honghatrip/city`);
      const airportNames = await $axios.$get(`/honghatrip/airport`);
      if (airportNames && response) {
        const airportsByCode = _.groupBy(airportNames.data.data, "code");
        const result = _.map(response.data.data, (item) => ({
          ...item,
          airports: airportsByCode[item.code] || [],
        }));
        setAirports(result);
      }
      setLoadingAirPorts(false);
    } catch (error) {
      showCustomNotification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };

  const getCountries = async () => {
    try {
      setLoadingAirPorts(true);
      const response = await $axios.$get(`/honghatrip/countries`);
      setCountries(response.data.data);
      setLoadingAirPorts(false);
    } catch (error) {
      showCustomNotification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };

  const getAirLines = async () => {
    try {
      const response = await $axios.$get(`/honghatrip/airline`);
      setAirlines(response.data.data);
    } catch (error) {
      showCustomNotification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };

  useEffect(() => {
    if (step && step === 1 && token) {
      getAirPorts();
      getAirLines();
      getCountries();
      getFareClass();
    }
  }, [step && token]);

  useEffect(() => {
    if (!chooseFlight.length) return;

    const now = moment();

    setChooseFlight((prev) =>
      prev.map((f) => {
        // nếu đã có rồi thì giữ nguyên → không trigger loop
        if (typeof f.isSameDayTicket === "boolean") return f;

        const startDate = moment(f?.options?.[0]?.flights?.[0]?.startdate);

        return {
          ...f,
          isSameDayTicket: startDate.isBefore(now.clone().add(24, "hours")),
        };
      })
    );
  }, [chooseFlight.length]);


  const handleBackButton = () => {
    setStep(1);
    setFilterDayReturn("");
    setFilterDay("");
  };

  return (
    <div className="home">
      <Spin
        tip={
          <div>
            <div className="text-[16px]">Yêu cầu đặt vé đang xử lý</div>
            <div className="text-[16px]">
              Xin quý khách vui lòng đợi trong giây lát...
            </div>
          </div>
        }
        size="large"
        spinning={loading}
      >
        {step === 0 && (
          <History
            airports={airports}
            onChangeStep={setStep}
            setLoading={setLoading}
            fareclass={fareclass}
            token={token}
          />
        )}
        {step === 1 && (
          <Step1
            onChangeStep={setStep}
            tripType={tripType}
            setTripType={setTripType}
            setAirport={setArrival}
            airport={arrival}
            airports={airports}
            chooseFlight={chooseFlight}
            setChooseFlight={setChooseFlight}
            setFilterDay={setFilterDay}
            setFilterDayReturn={setFilterDayReturn}
            loadingAirPorts={loadingAirPorts}
            form={form}
            token={token}
          />
        )}
        {step === 2 && (
          <Step2
            onChangeStep={setStep}
            listFilght={listFlight}
            chooseFlight={chooseFlight}
            setChooseFlight={setChooseFlight}
            tripType={tripType}
            airport={arrival}
            airports={airports}
            setStep={setStep}
            filterDay={filterDay}
            setFilterDay={setFilterDay}
            filterDayReturn={filterDayReturn}
            setFilterDayReturn={setFilterDayReturn}
            loadingSearchFlight={loadingSearchFlight}
            ChoosingStep={ChoosingStep}
            setChoosingStep={setChoosingStep}
            onBackButton={handleBackButton}
          />
        )}
        {step === 3 && (
          <Step3
            onChangeStep={setStep}
            setFilterDay={setFilterDay}
            setChoosingStep={setChoosingStep}
            setChooseFlight={setChooseFlight}
            tripType={tripType}
            chooseFlight={chooseFlight}
            setLoading={setLoading}
            onChangeBookingInfo={(e) => {
              handleBookingInfo(e);
              sessionStorage.setItem("bookingInfo", JSON.stringify(e));
            }}
            airports={airports}
            airlines={airlines}
            setStep={setStep}
            countries={countries}
          />
        )}
        {step === 4 && (
          <Step4
            onChangeStep={setStep}
            bookingInfo={bookingInfo}
            chooseFlight={chooseFlight}
            airports={airports}
            setLoading={setLoading}
          />
        )}
        {step === 5 && (
          <Step5
            setLoading={setLoading}
            bookingInfo={bookingInfo}
            chooseFlight={chooseFlight}
            airports={airports}
          />
        )}
        {step === 6 && (
          <Step6
            setLoading={setLoading}
            onChangeStep={setStep}
            loading={loading}
          />
        )}

        <RepaymentModal
          visible={openRepaymentModal}
          airports={airports}
          onClose={() => {
            setOpenRepaymentModal(false);
            setDataRepayment(null);
            dispatch(setIsViewedUnpaidOrder(true));
          }}
          data={dataRepayment}
        />
      </Spin>
    </div>
  );
};

export default Home;
